import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { FileController } from "services/file/FileController";
import { useFetchState } from "utils/customHooks/useFetchState";
import classes from "./Avatar.module.scss";

const Avatar = ({ filename, requestUpdateAvatar }) => {
  const imageRef = useRef();
  const fileController = FileController();
  const [selectedImage, setSelectedImage] = useState("");
  const [uploadState, sendRequest] = useFetchState();
  const [downloadState, fetchDownload] = useFetchState();
  const handleFileSelect = (e) => {
    const file = e.target.files[0];

    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      const formData = new FormData();
      formData.append("file", file);
      formData.append("Content-Type", "image/png");
      sendRequest(fileController.upload, formData);
    }
  };

  useEffect(() => {
    if (filename) {
      fetchDownload(fileController.download, filename);
    }
  }, [filename]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      !downloadState.isLoading &&
      !downloadState.isError &&
      downloadState.data
    ) {
      try {
        const blob = new Blob([downloadState.data]);
        const file = new File([blob], "");
        setSelectedImage(URL.createObjectURL(file));
      } catch (e) {}
    }
  }, [downloadState]);

  useEffect(() => {
    if (!uploadState.isLoading && !uploadState.isError && uploadState.data) {
      requestUpdateAvatar(uploadState.data.filename);
    }
  }, [uploadState]); //eslint-disable-line
  return (
    <label htmlFor="avatar-file" className={`${classes["profile-pic"]}`}>
      <input
        type="file"
        accept=".jpg, .png"
        className={"d-none"}
        id={"avatar-file"}
        onChange={handleFileSelect}
      />

      <div
        className={classNames(classes["image-wrapper"], {
          [classes["overlay"]]:
            uploadState.isLoading || downloadState.isLoading,
          [classes["loading"]]:
            uploadState.isLoading || downloadState.isLoading,
        })}
      >
        {selectedImage && (
          <img ref={imageRef} src={selectedImage} alt="Avatar" />
        )}
        <div
          className={classNames("icon-user-outline", classes["user-icon"], {
            [classes["img-loading"]]:
              uploadState.isLoading || downloadState.isLoading,
          })}
        />
      </div>
    </label>
  );
};

export default Avatar;
